<div class="ratingPanel">
    <p>Bewertung</p>
    <div (click)="filterRating(1)"></div>
    <div (click)="filterRating(2)"></div>
    <div (click)="filterRating(3)"></div>
    <div (click)="filterRating(4)"></div>
    <div (click)="filterRating(5)"></div>
</div>